import { MuvenRoleEnum } from "@c2b/muven-commons";

export class SubscriberMemberModel {
    id: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    username: string = "";
    isActive: boolean = false;
    expireAt: Date|string|null = null;
    roles: MuvenRoleEnum[] = [];
    loadingListAction: boolean = false;

    constructor(s?:Partial<SubscriberMemberModel>) {
        Object.assign(this, s)

        this._parseExpiration()
    }

    getRolesDescription():string {
        if (!this.roles.length) {
            return ""
        }

        let description = ""

        for (const role of this.roles) {
            switch (role) {
                case MuvenRoleEnum.administrator:
                    description += 'Administrador, '
                    break;

                case MuvenRoleEnum.sponsor:
                    description += 'Responsável financeiro, '
                    break;
            }
        }

        return description.replace(/, $/, '')
    }

    hasRole():boolean {
        return !!this.roles.length
    }

    getFullName():string {
        if (!this.firstName && !this.lastName) {
            return ""
        }

        if (!this.lastName) {
            return this.firstName
        }

        if (!this.firstName) {
            return this.lastName
        }

        return `${this.firstName} ${this.lastName}`
    }

    canBeShown():boolean {
        return this.username !== 'deveric'
    }

    private _parseExpiration():void {
        if (this.expireAt) {
            this.expireAt = new Date(this.expireAt)
        }
    }
}
